import { Property } from 'generated/graphql'
import React, { ReactElement } from 'react'
import { FaBed, FaBath, FaCar } from 'react-icons/fa'
import { VscSymbolRuler } from 'react-icons/vsc'
import { Center, Skeleton, Text } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

const StatElement: React.FC<{
  amount: number
  label?: string | null
  loading?: boolean
  icon: ReactElement
}> = ({ amount, label, icon, loading }) => (
  <Skeleton isLoaded={!loading}>
    <Center>
      {icon}
      <Text fontSize="x-small" fontWeight="extrabold" textAlign="left" mx={2}>
        {amount}
      </Text>
      {label && (
        <Text fontWeight="bold" fontSize="xs">
          {label}
        </Text>
      )}
    </Center>
  </Skeleton>
)

type PropertyStatInfosProps = {
  propertyData: Property
  loading?: boolean
  withLable?: boolean
}

const PropertyStatInfos: React.FC<PropertyStatInfosProps> = ({
  propertyData: property,
  loading,
  withLable
}) => {
  const { t } = useTranslation()
  return (
    <>
      {property?.bedrooms && (
        <StatElement
          icon={<FaBed color="gray" size={16} />}
          label={withLable ? t('property_details.room') + '(s)' : undefined}
          loading={loading}
          amount={property?.bedrooms}
        />
      )}
      {property?.bathrooms && (
        <StatElement
          icon={<FaBath color="gray" size={16} />}
          label={withLable ? t('property_details.bathroom') : undefined}
          loading={loading}
          amount={property?.bathrooms}
        />
      )}
      {property?.parking && (
        <StatElement
          icon={<FaCar color="gray" size={16} />}
          label={withLable ? t('property_details.parking') : undefined}
          loading={loading}
          amount={property?.parking}
        />
      )}
      {property?.floor_size && (
        <Skeleton mr={2} isLoaded={!loading}>
          <Center>
            <VscSymbolRuler color="gray" size={16} />
            <Text fontSize="xs" fontWeight="extrabold" mx={2}>
              {property?.floor_size} m
              <Text as="sup" fontSize="x-small">
                2
              </Text>
            </Text>
            {withLable && <Text fontSize="sm">{t('property_details.floor_size')}</Text>}
          </Center>
        </Skeleton>
      )}
    </>
  )
}

PropertyStatInfos.defaultProps = {
  withLable: false
}

export default PropertyStatInfos
